import { formatDate } from "@angular/common";
import { AppConstants } from "./app-constants";

export class AppFunctions{

    static numberWithSpaces(x: string) {
        var parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    }

    static numberWithComma(x: string) {
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
  }

    static removeEmpty (obj1: any): any {
      let obj = JSON.parse(JSON.stringify(obj1));
      Object.keys(obj).forEach(k =>
        (obj[k] && typeof obj[k] === 'object') && this.removeEmpty(obj[k]) ||
        (obj[k] === '[]') && delete obj[k] ||
        (!obj[k] && obj[k] !== 'undefined') && delete obj[k] 
      );
      return obj;
    }

    static stringToDatetimeEN(dt: string){

      return (dt !== "" && dt != undefined)? formatDate(dt,'dd/MM/yyyy hh:mm', 'en-US'): "";
    }

    static stringToDatetime(dt: string){
      try {
        return formatDate(dt,'dd MMM yyyy hh:mm', 'en-US');
      } catch (err) {
          return "";
      }
      //return (dt !== "" && dt != undefined && dt != 'null')? formatDate(dt,'dd MMM yyyy hh:mm', 'en-US'): "";
    }

    static stringToDateEN(dt: string){

      return (dt !== "" && dt != undefined)? formatDate(dt,'dd MMM yyyy', 'en-US'): "";
    }

    static stringToDate(dt: string){
      try {
        return formatDate(dt,'dd MMM yyyy', 'en-US');
      } catch (err) {
          return "";
      }
      //return (dt !== "" && dt != undefined && dt != null)? formatDate(dt,'dd MMM yyyy', 'en-US'): "";
    }


    public static deepCopy<T>(source: any): any {
      return Array.isArray(source)
      ? source.map(item => this.deepCopy(item))
      : source instanceof Date
      ? new Date(source.getTime())
      : source && typeof source === 'object'
            ? Object.getOwnPropertyNames(source).reduce((o, prop) => {
                Object.defineProperty(o, prop, Object.getOwnPropertyDescriptor(source, prop)!);
                o[prop] = this.deepCopy((source as { [key: string]: any })[prop]);
                return o;
            }, Object.create(Object.getPrototypeOf(source)))
      : source as T;
    }

    public static replaceValues(object: any, replacementValues: any){
      Object.keys(replacementValues).forEach(function(key) {
        if (replacementValues[key] != null ) {
          if(object[key] != undefined) {
            if(object[key].constructor === Array && replacementValues[key].constructor !== Array){
              object[key] = [replacementValues[key]];
            }
            else{
              object[key] = replacementValues[key];
            }
          }
        }
      })
    }

    public static getCarYearsBD(): number[]{
      let years: number[] = [];
      let max: number = new Date().getFullYear();
      let min = AppConstants.CAR_YEAR_MIN;

      while(max >= min ){
        years.push(max);
        max --;
      }

      return years;
    }

    public static getRatingsAverage(ratingsCounts: number[]): any{
      let totalSum = 0;
      let totalCount = 0;
  
      let i = ratingsCounts.length;
  
      while(i>0){
        totalSum+= ratingsCounts[i-1] * i;
        totalCount+= ratingsCounts[i-1];
        i--;
      }
  
      return ((totalCount === 0) ? 0 : totalSum/totalCount).toFixed(2);
    }
  
    public static getArraySum(array: number[]){
      return array.reduce((a, b) => a + b, 0);
    }

}